import React from "react";
import "./TopScrollBar.css";

const messages = [
  "Flat 10% OFF • Use Code FIRST",
  "Premium Arabica Coffee",
  "Pure Coffee. Pure Energy",
  "Free Delivery Available",
];

const TopScrollBar = () => {
  return (
    <div className="top-scroll-container">
      <div className="top-scroll-content">
        {Array(10)
          .fill(messages)
          .flat()
          .map((text, index) => (
            <span key={index} className="scroll-text">
              {text}
            </span>
          ))}
      </div>
    </div>
  );
};

export default TopScrollBar;
